import React from 'react';
import { Typography, Modal, CloseIcon } from '@ag1/ui';
import { CustomPortableText } from 'shared/studio/PortableText';
import { Variant3Props } from './types';
import styles from './Variant3.module.scss';

export const PopupVariant3 = ({
  closePopup,

  _key: key,
  headline,
  text,
  richTextField,
  isOpen
}: Variant3Props) => (
  <Modal isOpen={isOpen} onClose={closePopup} mode="fullScreen" className={styles.modal}>
    <div id={key} className={styles.modalContainer}>
      <div className={styles.modalInner}>
        <button type="button" className={styles.modalButtonClose} onClick={closePopup}>
          <CloseIcon size={24} />
        </button>
        <div>
          <Typography
            variant="headlineSans"
            size="2"
            noPadding
            className={styles.headline}
            color="black-new">
            <CustomPortableText value={headline} />
          </Typography>
          <Typography
            component="div"
            variant="body"
            size="1"
            noPadding
            className={styles.text}
            color="black-new">
            <CustomPortableText value={text} />
          </Typography>
          {richTextField ? (
            <Typography
              component="div"
              variant="body"
              className={styles.descriptionItems}
              size="1"
              noPadding
              color="black-new">
              <CustomPortableText value={richTextField} />
            </Typography>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  </Modal>
);
